import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useQueryParam, StringParam } from 'use-query-params';

import { loadFormDefinition } from '@redux/modules/formGeneration';
import {
  selectFormDefinition,
  selectFormDefinitionType,
} from '@redux/selectors/FormSelector';

import CreateOfficeForm from '@components/form/forms/CreateOfficeForm';

const CreateOfficePage = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const currentFormDefinition = useSelector(selectFormDefinition);
  const currentFormDefinitionType = useSelector(selectFormDefinitionType);
  const [urlParamFormType, setUrlParamFormType] = useQueryParam('formType', StringParam); // listing type of current listing from CLF

  const alertUser = e => {
    e.preventDefault(); // cancel the event
    e.returnValue = ''; // chrome requires return value to be set
  };

  useEffect(() => {
    window.addEventListener('beforeunload', alertUser);

    if (urlParamFormType && (!currentFormDefinition?.length || (urlParamFormType !== currentFormDefinitionType))) {
      dispatch(loadFormDefinition('create', urlParamFormType));
    }

    return () => window.removeEventListener('beforeunload', alertUser);
  }, []);

  /*
    This has to be done using location. Currently, when the user loads a form, it redirects the user to the
      create/edit page. When this happens, it clears out the path and search values in the location object.
      We can't memo the location and use that as a comparison, because technically the locations will be
      the same on the reload, so we can't reset the search value in the location object.
  */
  useEffect(() => {
    if (location?.search === '') {
      setUrlParamFormType('office');
    }
  }, [location]);

  return (
    <>
      <div className="subheader">
        <h1 className="subheader-title">
          <i className="subheader-icon fal fa-ballot mr-2" />
          Create
          <span className="fw-300 ml-2 mr-2">Office</span>
        </h1>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <CreateOfficeForm />
        </div>
      </div>
    </>
  );
};

export default CreateOfficePage;
